<div class="dropdown" appDropdown>
  <div class="link dropdown-title sort-by">
    Trier par
    <span class="arrow"></span>
    <div class="dropdown-content dropdown-content-link">
      <div class="classic-content">
        <form [formGroup]="form" class="item">
          <div class="bloc-input" *ngIf="hasWish">
            <input formControlName="order" [value]="'wish,desc'" type="radio" id="wish_recipe">
            <label class="radio" for="wish_recipe">Ajout récent</label>
          </div>
          <div class="bloc-input">
            <input formControlName="order" [value]="'star,desc'" type="radio" id="populare_recipe">
            <label class="radio" for="populare_recipe">Recettes Populaires</label>
          </div>
          <div class="bloc-input">
            <input formControlName="order" [value]="'id,desc'" type="radio" id="news">
            <label class="radio" for="news">Nouveautés</label>
          </div>
          <div class="bloc-input">
            <input formControlName="order" [value]="'difficulty,asc'" type="radio" id="difficulty_asc">
            <label class="radio" for="difficulty_asc">Recettes Faciles</label>
          </div>
          <div class="bloc-input">
            <input formControlName="order" [value]="'difficulty,desc'" type="radio" id="difficulty_desc">
            <label class="radio" for="difficulty_desc">Recettes Difficiles</label>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
